import React from "react";
import Home from "./Pages/Home";
import { useViewportHeightVar } from "./hooks/use-viewport-height";
import "@fontsource/poppins/500.css";
import "@fontsource/poppins/400.css";
import "@fontsource/poppins/300.css";
import "@fontsource/archivo-black";
import "@fontsource/inter";

const App = () => {
  useViewportHeightVar();
  return <Home />;
};

export default App;
